interface Props {
  isActive: boolean;
}

/**
 * Two-state pill for custom URLs: Active (sage) vs Inactive (muted grey).
 * Follows the same pattern as LandingStatusPill so all listings feel
 * consistent.
 */
export function CustomUrlStatusPill({ isActive }: Props) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-[11px] font-medium ${
        isActive ? "text-sage [&_.dot]:bg-sage" : "text-ink-4 [&_.dot]:bg-ink-5"
      }`}
    >
      <span className="dot inline-block h-[6px] w-[6px] rounded-full" />
      {isActive ? "Active" : "Inactive"}
    </span>
  );
}
